module.exports = __webpack_public_path__ + "img/4d881c7e40d603b2c986d0fd6107a45a.jpg";